import React, { Component } from 'react'
import './Manifesto.css'

export default class Manifesto extends Component {
    render() {
        return (
            <div className="Manifesto d-flex">
                <div className="container">
                    <div className="row notebook">
                        <div className="col-xs-12 d-flex align-items-md-center">
                            <div className="row">
                                <div className="col-xs-12 col-sm-4">
                                    <img src={this.props.icon} alt={this.props.name} className="img-fluid" />
                                </div>
                                <div className="col-xs-12 col-sm-8">
                                    <h3 className="text-center">
                                        {this.props.name}
                                    </h3>
                                    <p>
                                        {this.props.body}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
